import React, { useRef, useEffect, useState, useContext } from 'react'
import { FaSquarePhone } from 'react-icons/fa6'

import {
  CloseButton,
  Footer,
  Header,
  IframeWrapper,
  StyledIframe,
  ToggleButton,
  WebPhoneContainer,
} from './styles'
import { useGlobalContext } from '~/contexts/GlobalContext'

export default function WebPhoneIframe() {
  const { showWebphoneRef } = useGlobalContext()

  const [isMinimized, setIsMinimized] = useState(true)
  const [position, setPosition] = useState({
    x: window.innerWidth - 365,
    y: 64,
  })
  const [dragging, setDragging] = useState(false)
  const [offset, setOffset] = useState({ x: 0, y: 0 })

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    showWebphoneRef.current = () => {
      setIsMinimized(false)
    }

    requestPermissions()
  }, [])

  const requestPermissions = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true })
      console.log('Microfone autorizado')
    } catch (err) {
      console.warn('Microfone não autorizado:', err)
    }

    if (Notification.permission !== 'granted') {
      Notification.requestPermission()
    }
  }

  // Configura eventos de arraste
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!dragging) return

      const newX = e.clientX - offset.x
      const newY = e.clientY - offset.y

      // Limitar dentro da tela
      setPosition({
        x: Math.max(0, Math.min(window.innerWidth - 360, newX)),
        y: Math.max(0, Math.min(window.innerHeight - 50, newY)),
      })
    }

    const handleMouseUp = () => {
      setDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [dragging, offset])

  const handleMouseDown = (e) => {
    setDragging(true)
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    })
  }

  return (
    <WebPhoneContainer
      left={position.x}
      top={position.y}
      minimized={isMinimized}
      onMouseDown={handleMouseDown}
      isDragging={dragging}
    >
      {isMinimized && (
        <button
          type="button"
          onClick={() => setIsMinimized(false)}
          aria-label="Maximizar WebPhone"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {/* <PhoneIcon /> */}
          <FaSquarePhone size={56} color="green" />
        </button>
      )}
      <>
        {!isMinimized && (
          <Header onMouseDown={handleMouseDown} hidden={isMinimized}>
            <span hidden={isMinimized}>📞 WebPhone</span>
            <ToggleButton
              onClick={() => setIsMinimized(!isMinimized)}
              hidden={isMinimized}
            >
              {isMinimized ? '☐ Maximizar' : '_ Minimizar'}
            </ToggleButton>
          </Header>
        )}

        <IframeWrapper hidden={isMinimized}>
          <StyledIframe
            src="https://easydesk.webphone.cloudcom.com.br"
            title="WebPhone"
            allow="microphone; autoplay; display-capture; fullscreen; camera; clipboard-read; clipboard-write; device-info; notifications; midi"
            sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups allow-presentation"
          />
          {/* <Footer>
            <CloseButton onClick={() => setIsVisible(false)}>
              Fechar
            </CloseButton>
          </Footer> */}
        </IframeWrapper>
      </>
    </WebPhoneContainer>
  )
}
